module.exports = __webpack_public_path__ + "GothamBook.ab0404a2ed79671a4e2b.eot";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/GothamBook.eot
// module id = ../../../../../src/assets/fonts/gotham/GothamBook.eot
// module chunks = styles